module.exports = __webpack_public_path__ + "img/light.403ce8a9.svg";